/**
 * Facing from movement delta in logical cell space.
 * Returns radians (0 = +X / east). Null when delta is negligible.
 */
export function facingFromDelta(
  dx: number,
  dy: number,
  epsilon = 1e-4
): number | null {
  if (dx * dx + dy * dy < epsilon * epsilon) return null
  return Math.atan2(dy, dx)
}

/** Smooth toward a target angle without spinning the long way. */
export function approachAngle(current: number, target: number, maxStep: number): number {
  let delta = target - current
  while (delta > Math.PI) delta -= Math.PI * 2
  while (delta < -Math.PI) delta += Math.PI * 2
  if (Math.abs(delta) <= maxStep) return target
  return current + Math.sign(delta) * maxStep
}
